import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { RandomString } from 'src/tools/index';

export const UNIVERSAL_LOADING_KEY = 'ANY_HTTP_ACTION';
@Injectable({
	providedIn: 'root',
})
export class LoadingIndicatorService {
	keys = new Map<string, number>();
	loadingStarted = new Subject<string>();
	loadingStopped = new Subject<string>();

	constructor() {}

	start(key?: string): string {
		if (key === undefined) {
			key = RandomString.generate();
		}
		const existingValue = this.keys.get(key) ?? 0;
		this.keys.set(key, existingValue + 1);
		this.loadingStarted.next(key);
		return key;
	}

	stop(key: string, delay: number = 0): void {
		setTimeout(() => {
			const existingValue = this.keys.get(key) ?? 0;
			const newValue = existingValue - 1;
			if (newValue <= 0) {
				this.keys.delete(key);
				this.loadingStopped.next(key);
			} else {
				this.keys.set(key, newValue);
			}
		}, delay);
	}

	isLoading(key: string = UNIVERSAL_LOADING_KEY): boolean {
		const loadingCount = this.keys.get(key) ?? 0;
		return loadingCount > 0;
	}
}
